import React from 'react';
import { SimpleGrid } from '@mantine/core';
import type { Scene } from '../../../data/ShellConfig';
import StudioDrawer from './StudioDrawer';
import SceneCard from './SceneCard';
import PlaceholderCard from './PlaceholderCard';

type AddSceneDrawerProps = {
    opened: boolean;
    onClose: () => void;
    /** Existing scenes to choose from. */
    scenes: Scene[];
    /** Called with the chosen scene id. */
    onPick: (sceneId: string) => void;
    /** Open the New scene builder. */
    onNewScene: () => void;
    /** Header — "Add scene" when appending, "New playlist" when picking a first scene. */
    title?: string;
    /** Overrides the drawer's stacking order — e.g. to open above a modal. */
    zIndex?: number;
};

/** Picker for adding a scene to a playlist: create a new one or reuse an existing one. */
const AddSceneDrawer: React.FC<AddSceneDrawerProps> = ({
    opened,
    onClose,
    scenes,
    onPick,
    onNewScene,
    title = 'Add scene',
    zIndex,
}) => (
    <StudioDrawer opened={opened} onClose={onClose} title={title} zIndex={zIndex}>
        <SimpleGrid cols={{ base: 2, sm: 3 }} spacing="md">
            <PlaceholderCard label="New scene" onClick={onNewScene} />
            {scenes.map(scene => (
                <SceneCard key={scene.id} name={scene.name} onClick={() => onPick(scene.id)} />
            ))}
        </SimpleGrid>
    </StudioDrawer>
);

export default AddSceneDrawer;
